export const LOGIN_USER = 'LOGIN_USER'
export const RECEIVE_USER_ACCT = 'RECEIVE_USER_ACCT'
export const LOGIN_INVALID = 'LOGIN_INVALID'
export const RESET_LOGIN_STATE = 'RESET_LOGIN_STATE'
